<template>
    <div class="product-choice-list">
        <div class="product-choice-scroll">
            <header class="product-choice-header">
                <h2>{{ resources.title }}</h2>
                <span>{{ resources.subtitle }}</span>
            </header>
            <div class="product-choice-options" ref="productChoiceOptions">
                <div v-for="option in products"
                    :class="['input-type-radio', {'chosen': selectedProductID === option.productID}]"
                    :key="option.productID">
                    <input type="radio" @click="onProductSelected(option)"
                        :id="option.productID"
                        :name="'bonusChoiceProducts'"
                        :value="option.productID"
                        :checked="selectedProductID === option.productID" />

                    <label :for="option.productID" class="vue-form-group-label">
                        <span class="option-ritual">
                            {{option.productHeading}}
                        </span>
                        <span class="option-title">
                            {{option.productName}}
                        </span>
                        <img
                            :src="option.productImagePlaceholder"
                            :alt="option.productImageAlt"
                            :class="option.productImageClass"
                            :data-src="option.productImageUrl">
                    </label>
                </div>
            </div>
        </div>

        <footer class="product-choice-footer">
            <a class="btn" @click="productPicked()" :title="resources.cta">
                {{ resources.cta }}
            </a>
        </footer>
    </div>
</template>
<script src="./product-choice-list.js"></script>
